// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmFunds-Error_cls1__MkAdd","cls2":"ConfirmFunds-Error_cls2__8ouiS ConfirmFunds-Error_cls1__MkAdd"};